import React, { useContext } from 'react';
import { Button as MuiButton } from '@mui/material';
import { CloneButton as RACloneButton, EditButton as RAEditButton } from 'react-admin';
import { ReadOnlyContext } from '../context/ReadOnlyContext';

export const Button = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <MuiButton variant="outlined" {...props} disabled={readonly} />;
};

export const CloneButton = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RACloneButton  {...props} disabled={readonly} />;
};

export const EditButton = (props) => {
    const readonly = useContext(ReadOnlyContext) || false;
    return <RAEditButton {...props} disabled={readonly} />;
};

